/**
 * Component: BasicLoadingIndicator
 * Centered circular spinner for general loading states. Accepts optional
 * className to adjust spacing or layout in the parent context.
 */
import React from 'react';

export function BasicLoadingIndicator({ className = '' }) {
  return (
    <div className={`flex justify-center items-center py-12 ${className}`}>
      <div className="animate-spin rounded-full h-16 w-16 border-4 border-gray-100 dark:border-gray-800 border-b-purple-600 dark:border-b-purple-400"></div>
    </div>
  );
}

export default BasicLoadingIndicator; 